import { apiGet } from 'APIPackage/MainModule/common/apiTools';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';

import { IKnmResponsibleType } from '../interfaces/IKnmResponsibleType';

export async function fetchKnmResponsibleTypes(): Promise<IKnmResponsibleType[]> {
  return apiGet<IKnmResponsibleType[]>(
    `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/erknm/knm-responsible-types`,
  );
}
